import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SearchProvider } from './context/SearchContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import MetersInstalled from './pages/MetersInstalled';
import Login from './pages/Login';
import PendingToVerify from './pages/PendingToVerify';
import Accepted from './pages/Accepted';
import Rejected from './pages/Rejected';
import FieldOfficers from './pages/FieldOfficers';
import Locations from './pages/Locations';
import Users from './pages/Users';
import TicketDashboard from './pages/TicketDashboard';
import TicketDetails from './pages/TicketDetails';
import Profile from './pages/Profile';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/" replace /> : children;
}

function Placeholder({ title }) {
  return (
    <div style={{ padding: 40, color: '#8f9bba', fontSize: '1.1rem' }}>
      <h2 style={{ color: '#0f1535' }}>{title}</h2>
      <p>This page is under development.</p>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SearchProvider>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/meters-installed" element={<MetersInstalled />} />
            <Route path="/pending-to-verify" element={<PendingToVerify />} />
            <Route path="/accepted" element={<Accepted />} />
            <Route path="/rejected" element={<Rejected />} />
            <Route path="/field-officers" element={<FieldOfficers />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/users" element={<Users />} />
            <Route path="/tickets" element={<TicketDashboard />} />
            <Route path="/tickets/:ticketId" element={<TicketDetails />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Placeholder title="Settings" />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer
          position="bottom-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
        />
        </SearchProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
